// @flow

import type { PropsSchema, EasyCompComponent, EasyAction } from '../../type'

export function appendPropsSchema (
  WrappedComponent: EasyCompComponent,
  schemaToAdd?: PropsSchema
) {
  // $FlowFixMe
  const preSchema: PropsSchema = WrappedComponent.schema
  if (!schemaToAdd) {
    return preSchema
  }
  const result: PropsSchema = [...schemaToAdd]
  if (preSchema && preSchema.length > 0) {
    result.splice(0, 0, ...preSchema, 'separator')
  }
  return result
}

export function prependPropsSchema (
  WrappedComponent: EasyCompComponent,
  schemaToAdd?: PropsSchema
) {
  // $FlowFixMe
  const preSchema: PropsSchema = WrappedComponent.schema
  if (!schemaToAdd) {
    return preSchema
  }
  const result: PropsSchema = [...schemaToAdd]
  if (preSchema && preSchema.length > 0) {
    result.push('separator', ...preSchema)
  }
  return result
}

export function appendPropsActions (
  WrappedComponent: EasyCompComponent,
  actions?: EasyAction[]
): EasyAction[] {
  return [
    // $FlowFixMe
    ...(WrappedComponent.actions || []),
    ...(actions || [])
  ]
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/util/schemaUtil.js